import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { GameAndFishDecalModel } from '../models/game-and-fish-decal.model';

@Injectable()
export class DecalService extends BaseApiService {

    /**
     * Gets a list of the decals based on the vehicle
     * @return: List of the decals associated to the vehicle
     */
    getDecalsByVehicleId = (vehicleId: number): Observable<any> => this.get('TitleRegistration/Decal/Vehicle/' + vehicleId);

    /**
     * Calculates the expiration date for a decal.
     * @return: Calculated expiration date.
     */
    calculateDecalExpirationDate = (decal: GameAndFishDecalModel): Observable<any> => this.post('TitleRegistration/Decal/ExpirationDate/Calculate', decal);

    /**
     * Calculates the expiration date for a decal renewal.
     * @return: Calculated expiration date.
     */
    calculateRenewDecalExpirationDate = (decal: GameAndFishDecalModel): Observable<any> => this.post('TitleRegistration/Decal/Renew/ExpirationDate/Calculate', decal);

    /**
     * Gets the latest decal by plateNumber.
     * @return: Calculated expiration date.
     */
    getMostRecentDecalByPlateNumber = (plateNumber: string): Observable<GameAndFishDecalModel> => this.get('TitleRegistration/Decal/Plate/' + plateNumber);
}
